/**
 * Permission codes the Idle Cash Report declares an interest in.
 *
 *  - `treasury.kpi.read` is what `GET /reports/idle-cash` declares
 *    (`server/internal/treasury/report_permissions.go`): a management door, not a
 *    row scope — a holder sees every bank account and wallet of the legal entity.
 *  - The drill links go to screens with their own doors: a wallet needs
 *    `treasury.wallet.read`, a bank account `cash.account.read`. A link the
 *    viewer cannot open is rendered as plain text, never as a link to a 403.
 */
export const IDLE_CASH_PERMISSIONS = {
  read: 'treasury.kpi.read',
  walletRead: 'treasury.wallet.read',
  bankAccountRead: 'cash.account.read',
} as const
